import React, { useState, useEffect } from "react";
import { Col, Container, Row, Button, Alert } from "react-bootstrap";
import { Link, Outlet } from "react-router-dom";
import "../../Style.css";
import AdminHeader from "../../common/Header";
import List from "../../components/listing/List";
import BreadCrumb from "../../components/breadcrumb/BreadCrumb";
import Api from "../../components/api/Api";
import { useSelector } from "react-redux";
import axios from "axios";
import Notification, {
  showToast,
} from "../../../components/common/notification/Notification";
import AllMessage from "../../../components/common/allMessage/AllMessage";
const LeadManagement = () => {
  const propertyApi = Api({
    url: "admin/users",
  });
  const [showDeleteAlert, setShowDeleteAlert] = useState(false);
  const loggedInUser = useSelector((state) => state.auth.user);
  const userId = loggedInUser?.user?.id;
  const token = loggedInUser?.refreshToken;
  const handleDeleteAlertClose = () => setShowDeleteAlert(false);
  const handleDeleteAlertShow = () => setShowDeleteAlert(true);
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const handleDelete = async (itemId) => {
    try {
      const response = await axios.get(
        `${baseUrl}/admin/deleteUser/${itemId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(response);
      if (response.data.statusType === "SUCCESS") {
        setData(data.filter((item) => item.id !== itemId));
        showToast("Lead deleted successfully", {
          type: "success",
        });
      } else {
        console.error(
          "Error 'deleting' item. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error 'deleting' item:", error);
    }
  };

  const [data, setData] = useState([]);
  const columns = [
    { displayName: "S.No.", key: "id" },
    { displayName: "First Name", key: "first_name" },
    // { displayName: "Last Name", key: "last_name" },
    // { displayName: "Mobile Number", key: "mobile_number" },
    { displayName: "Email Address", key: "email_address" },
    { displayName: "User Type", key: "userType.name" },
  ];
  useEffect(() => {
    const fetchPropertyData = async () => {
      try {
        const responseData = await propertyApi.fetchData();
        setData(responseData.data.users);
        console.log(responseData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchPropertyData();
  }, []);
  return (
    <>
      <Notification />
      <div className="content-body">
        <Container>
          {/* Delete Alert */}
          <BreadCrumb data="All Lead" />
          <Alert
            show={showDeleteAlert}
            variant="danger"
            onClose={handleDeleteAlertClose}
            dismissible
          >
            <Alert.Heading>Confirm Delete</Alert.Heading>
            <p>Are you sure you want to delete this user?</p>
            <div className="d-flex justify-content-end">
              <Button
                onClick={handleDeleteAlertClose}
                variant="outline-danger"
                className="me-3"
              >
                Cancel
              </Button>
              <Button onClick={handleDelete} variant="danger">
                Delete
              </Button>
            </div>
          </Alert>

          <Row>
            <Col md={2}>
              <AdminHeader />
            </Col>
            <Col md={10}>
              {data.length === 0 ? (
                <>
                  <Row>
                    <Col>
                      <AllMessage title="No Lead Found" />
                    </Col>
                  </Row>

                  <Col
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      width: "100%",
                    }}
                  >
                    <Link to={"/lead/add-lead"} className="btn btn-primary">
                      Add Lead
                    </Link>
                  </Col>
                </>
              ) : (
                <List
                  title="All Lead"
                  data={data}
                  columns={columns}
                  button="Add Lead"
                  to="/lead/add-lead"
                  route="lead"
                  edit="edit"
                  handleDelete={handleDelete}
                />
              )}
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default LeadManagement;
